import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  TableWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
    overflowX: "auto", // Enable horizontal scroll
    "& .pagination-wrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      overflow: "hidden",
      "& .MuiTablePagination-select": {
        paddingRight: "24px !important",
      },
      "@media (max-width: 575px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "15px",
      },
      "@media (max-width: 374px)": {
        padding: "0",
      },
      "& .total-page p": {
        opacity: "0.7",
        "@media (max-width: 575px)": {
          marginBottom: "15px",
        },
      },
      "& .pagination": {
        display: "flex",
        alignItems: "center",
        "& li": {
          margin: "0 2px",
          "&:last-child": {
            marginLeft: "8px",
          },
          "&:first-child": {
            marginRight: "8px",
          },
          "&:hover a": {
            color: colors.white,
            borderColor: colors.orange,
            backgroundColor: colors.orange,
          },
          "&.no-link": {
            margin: "0 8px",
          },
          "&.disabled a": {
            opacity: "0.3",
            cursor: "default",
            color: colors.black,
            borderColor: "#c6cbd4",
            backgroundColor: "transparent",
          },
          "&.active a": {
            color: colors.white,
            borderColor: colors.orange,
            backgroundColor: colors.orange,
          },
          "& a": {
            border: "solid 1px #c6cbd4",
            fontSize: "14px",
            color: colors.black,
            padding: "0px 10px",
            lineHeight: "1.2",
            borderRadius: "2px",
            height: "32px",
            width: "32px",
            display: "flex",
            textAlign: "center",
            textDecoration: "none !important",
            alignItems: "center",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
              height: "14px",
              width: "14px",
            },
          },
        },
      },
    },
  },
  customTable: {
    marginTop: 25,
    maxHeight: 400,
    boxShadow: "none",
    "& .MuiTable-root": {
      minWidth: 1600,
      "@media (max-width: 1600px)": {
        width: "1800px",
      },
      "& .MuiTableRow-root": {
        "&.accordian-row": {
          transition: "all 0.3s",
          cursor: "pointer",
        },
        "&.sub-row": {
          "& .MuiTableSubRoW": {
            paddingBottom: 0,
            paddingTop: 0,
          },
          "& .MuiTableCell-root": {
            "&:first-child": {
              paddingLeft: "0px",
            },
            "&:last-child": {
              paddingRight: "0px",
            },
            "& .MuiTable-root": {
              minWidth: 1600,
              "& .MuiTableRow-root": {
                cursor: "default",
              },
              backgroundColor: "#f6f6f6",
              "& .MuiTableCell-root": {
                padding: "22px 10px",
              },
            },
          },
        },
      },
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "12px 16px",
          backgroundColor: colors.white,
          wordBreak: "break-word",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "22px 16px",
          wordBreak: "break-word",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
          "& span": {
            display: "block",
          },
          "&.newInvoiceDateInput": {
            width: 200,
            "& p.Mui-error": {
              fontSize: 11.5,
            }
          },
          "&.newInvoiceDateText": {
            width: 140,
          }
        },
      },
      "& .invoice": {
        width: "120px",
      },
      "& .invoiceDate": {
        width: "125px",
      },
      "& .job": {
        width: "120px",
      },
      "& .jobDate": {
        width: "120px",
      },
      "& .previousRate": {
        color: colors.red2,
        width: "110px",
        textAlign: "center",
      },
      "& .originalJobCharge": {
        width: "150px",
        textAlign: "center",
      },
      "& .newJobCharge": {
        width: "150px",
        textAlign: "center",
      },
      "& .difference": {
        width: "135px",
        textAlign: "center",
      },
      "& .originalInvoiceAmount": {
        width: "180px",
        textAlign: "center",
      },
      "& .newInvoice": {
        width: "120px",
      },
      "& .newInvoiceAmount": {
        width: "150px",
        textAlign: "center",
      },
      "& .differenceAmountInvoice": {
        width: "150px",
        textAlign: "center",
      }

    },
  },
});

export { TableStyle };
